module.exports = __webpack_public_path__ + "static/img/maria-verde.f1f7b98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photoPeople/maria-verde.png
// module id = lYvS
// module chunks = 1